import { Link } from "react-router-dom";
import { useRentalsFeature } from "../../context/RentalsFeatureContext";

export default function RequireRentalsFeature({ children }) {
  const { enabled, loading } = useRentalsFeature();

  if (loading) {
    return (
      <div className="flex min-h-[240px] items-center justify-center text-sm text-slate-500">
        Loading rentals settings...
      </div>
    );
  }

  if (!enabled) {
    return (
      <div className="mx-auto max-w-3xl px-4 py-10">
        <div className="rounded-3xl border border-slate-200 bg-white p-8 shadow-sm">
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-rose-500">
            Rentals Disabled
          </p>
          <h1 className="mt-3 text-2xl font-semibold text-slate-900">
            Turn on rentals in setup before using this area
          </h1>
          <p className="mt-3 text-sm leading-6 text-slate-600">
            Ellyanna keeps rentals behind the business-level feature flag. Enable
            booth rental in setup to unlock rentals inventory and settings for this
            business.
          </p>
          <Link
            to="/setup"
            className="mt-6 inline-flex rounded-full bg-rose-500 px-5 py-2.5 text-sm font-semibold text-white hover:bg-rose-600"
          >
            Open Setup
          </Link>
        </div>
      </div>
    );
  }

  return children;
}
